import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { CrossIcon, MenuIcon } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';

import { HeaderLinksMobile } from './HeaderLinksMobile';
import LocalTexts from './HeaderTexts.json';
import { NavTree } from './NavTree';
import { useHeaderNav } from './useHeaderNav';

import styles from './Header.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string) => LocalT.translate(key) as string;

export const HeaderLinks = () => {
  const {
    activeGroup,
    fireMenuHoverTracking,
    fireTrackingEventForLink,
    handleOnLogOutClick,
    isExternalLink,
    isMobile,
    isUser,
    menuOpen,
    navRoutes,
    setActiveGroup,
    setMenuOpen,
  } = useHeaderNav();

  const navProps = {
    activeGroup,
    fireMenuHoverTracking,
    fireTrackingEventForLink,
    handleOnLogOutClick,
    isExternalLink,
    isUser,
    navRoutes,
    setActiveGroup,
  };

  return (
    <>
      <a
        className={styles.mobileMoreMenu}
        {...applyCypressData(cypressIds.menus.mobileHamburgerMenu)}
        href="#menu"
        onClick={(e) => {
          e.preventDefault();
          setMenuOpen(!menuOpen);
        }}
      >
        {t('navigation.openMenuLabel')}
        {menuOpen ? <CrossIcon /> : <MenuIcon />}
      </a>

      <nav className={cx(styles.nav, styles.links, styles.navDesktop)}>
        <NavTree {...navProps} variant='desktop' />
      </nav>
      {
        isMobile && (
          <HeaderLinksMobile
            {...{
              menuOpen,
              setMenuOpen,
            }}
          >
            <NavTree {...navProps} variant='mobile' />
          </HeaderLinksMobile>
        )
      }
    </>
  );
};
